let formiePromise = null;
const loadFormie = () => {
  if (window.Formie) return Promise.resolve(window.Formie);
  if (formiePromise) return formiePromise;

  formiePromise = new Promise((resolve, reject) => {
    const src = document.querySelector('meta[name="formie-js"]')?.content;
    if (!src) {
      reject(new Error('Formie JS URL missing — expected <meta name="formie-js">.'));
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.setAttribute('data-manual-init', '');
    script.addEventListener('load', () => resolve(window.Formie), { once: true });
    script.addEventListener('error', () => {
      formiePromise = null;
      reject(new Error('Formie JS failed to load.'));
    }, { once: true });
    document.head.appendChild(script);
  });

  return formiePromise;
};

up.compiler('form[data-fui-form]', (form) => {
  let initialised = false;
  let destroyed = false;
  let removeSubmitGuard = () => {};

  const initialise = () => {
    if (initialised) return;
    initialised = true;

    loadFormie().then((Formie) => {
      if (destroyed || !Formie || !form.isConnected) return;

      let ready = false;
      const submits = form.querySelectorAll('[type="submit"]');
      const blockSubmit = (event) => {
        if (!ready) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      submits.forEach((button) => { button.disabled = true; });
      form.addEventListener('submit', blockSubmit, true);

      removeSubmitGuard = () => {
        form.removeEventListener('submit', blockSubmit, true);
        removeSubmitGuard = () => {};
      };

      const { formHashId, registeredJs = [] } = JSON.parse(form.getAttribute('data-fui-form') || '{}');

      registeredJs.forEach(({ module, settings }) => {
        if (module === 'FormieJSCaptcha' && settings?.sessionKey) {
          window[`Formie${settings.sessionKey}`] = settings.value;
        }
      });

      Promise.resolve(Formie.initForm(form))
        .then(() => {
          if (destroyed || !form.isConnected || !formHashId) return;
          return Formie.refreshForCache(formHashId);
        })
        .finally(() => {
          ready = true;
          submits.forEach((button) => { button.disabled = false; });
          removeSubmitGuard();
        });
    }).catch((error) => {
      console.error('[formie-unpoly]', error.message);
    });
  };

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      observer.disconnect();
      initialise();
    }
  }, { rootMargin: '200px' });

  observer.observe(form);

  return () => {
    destroyed = true;
    observer.disconnect();
    removeSubmitGuard();
    const Formie = window.Formie;
    const instance = Formie && Formie.getForm(form);
    if (instance && Formie.destroyForm) Formie.destroyForm(instance);
  };
});
